import { apiRequest } from './client';

export const submitQvFeedback = ({ token, payload }) => apiRequest('https://api.exanta.ai/api/v1/qv_feedback', {
  method: 'POST',
  mode: 'cors',
  token,
  body: payload
});
